<template>
  <v-card class="py-2 mt-3 mb-2" outlined>
    <div class="people-title-container px-4">
      <p class="d-flex align-center text-subtitle-1 font-weight-medium">
        {{ $t('common.member_other') }}

        <v-skeleton-loader class="ml-4 mt-2" type="text" width="20" />
      </p>
    </div>

    <div class="mt-4 px-4">
      <p class="d-flex text-subtitle-2 blue-grey--text">
        {{ $t('teams.leader_other') }}

        <v-skeleton-loader class="ml-2 mt-1" type="text" width="20" />
      </p>

      <v-card flat class="d-flex py-2">
        <v-skeleton-loader class="mr-4" type="text" width="32" />

        <v-skeleton-loader type="text" width="120" />
      </v-card>
    </div>

    <div class="mt-2 px-4">
      <p class="d-flex text-subtitle-2 blue-grey--text">
        {{ $t('common.member_other') }}
        <v-skeleton-loader class="ml-2 mt-1" type="text" width="20" />
      </p>

      <v-card flat class="d-flex py-2">
        <v-skeleton-loader class="mr-4" type="text" width="32" />

        <v-skeleton-loader type="text" width="120" />
      </v-card>

      <v-card flat class="d-flex py-2">
        <v-skeleton-loader class="mr-4" type="text" width="32" />

        <v-skeleton-loader type="text" width="120" />
      </v-card>

      <v-card flat class="d-flex py-2">
        <v-skeleton-loader class="mr-4" type="text" width="32" />

        <v-skeleton-loader type="text" width="120" />
      </v-card>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'TeamMembersSkeleton',
}
</script>

<style lang="scss" scoped>
.people-title-container {
  border-bottom: 1px solid $color-blue-grey-lighten2;
}
</style>
